import { render } from "./ColumnSelect.vue?vue&type=template&id=254c9244&scoped=true&ts=true"
import script from "./ColumnSelect.vue?vue&type=script&lang=ts"
export * from "./ColumnSelect.vue?vue&type=script&lang=ts"

import "./ColumnSelect.vue?vue&type=style&index=0&id=254c9244&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254c9244"]])

export default __exports__